import { useSelector } from 'react-redux';
import { CustomReduxState } from '../../types/state';

export function useCustomLogin() {
  return useSelector((state: CustomReduxState) => state.loginPage);
}
